import env from 'src/@legacy/utilities/env'
import { createAPIClient } from './APIClient/CreateApiClient'

export default createAPIClient(env.PUBLIC_ENABLE_API_PROXY ? '/' : env.PUBLIC_API_END_POINT)
